export const RAK_VALUE_PACKAGE_PATH = "prospect.applicationInfo.rakValuePackage";

export const WOMEN_ENTERPRENEURSHIP_TERMS_AND_CONDITIONS_URL =
  "https://www.rakbank.ae/globalassets/rakbank/all-pdfs/001---terms-and-conditions/we_proposition_tnc.pdf";
